module.exports = __webpack_public_path__ + "static/img/icon3.757c95f9.png";